module.exports = __webpack_public_path__ + "img/dum1.76225948.png";